export function toMillions(value: number) {
  return value / 1000000;
}
